const state = {
  list: [],
  selectedBlockListEntry: null,
};

const getters = {
  globalBlockList: (state) => state.list,
  selectedBlockListEntry: (state) => state.selectedBlackistEntry,
};

const actions = {
  async fetchGlobalBlockListEntry({ commit }, { blockId }) {
    const response = await this._vm.$http.get(`/restapi/block/${blockId}`);

    commit("updateBlockListEntry", response.data);
    commit("setSelectedBlackistEntry", response.data);
  },

  async fetchGlobalBlockList({ commit }) {
    const response = await this._vm.$http.get(`/restapi/block/`);

    commit("setGlobalBlockList", response.data);
  },

  async createGlobalBlockListEntry({ commit }, { body }) {
    const response = await this._vm.$http.post(`/restapi/block`, body);

    commit("addBlockListEntry", response.data);
    return response.data;
  },

  async updateGlobalBlockListEntry({ commit }, { blockId, body }) {
    const response = await this._vm.$http.post(
      `/restapi/block/${blockId}`,
      body
    );

    const index = state.list.findIndex(
      (blockEntry) => blockEntry.id === response.data.id
    );

    if (index === -1) {
      commit("addBlockListEntry", response.data);
    } else {
      commit("updateBlackistEntry", {
        idx: index,
        blockListEntry: response.data,
      });
    }
  },

  async importGlobalBlockListEntries({ commit }, { body }) {
    const response = await this._vm.$http.post(`/restapi/block/`, body);

    commit("importBlockListEntries", response.data);
  },

  async deleteGlobalBlockListEntry({ commit }, { blockId }) {
    const response = await this._vm.$http.delete(`/restapi/block/${blockId}`);

    commit("deleteblockListEntry", response.data);
  },
};

const mutations = {
  setGlobalBlockList: (state, data) => (state.list = data.data),
  setSelectedBlackistEntry: (state, data) =>
    (state.selectedBlackistEntry = data),
  addBlockListEntry: (state, data) => state.list.push(data),
  updateBlackistEntry: (state, data) =>
    (state.list[`${data.idx}`] = data.blockListEntry),
  importBlockListEntries: (state, data) =>
    (state.list = [...state.list, ...data]),
  deleteblockListEntry: (state, data) =>
    (state.list = state.list.filter(
      (blockListEntry) => blockListEntry.id !== parseInt(data.id)
    )),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
